import React from "react";

const BrowsingHistory = () => (
  <div className="tab-pane fade" id="tab-history" />
);

export default BrowsingHistory;
